{
  "*": {
    "shadow": {
      "type": "string",
      "title": "Shadow",
      "format": "shadow",
      "group": "Styles",
      "hidden": true
    },
    "border": {
      "type": "border",
      "title": "Border",
      "group": "Styles",
      "hidden": true
    },
    "top": {
      "type": "string",
      "title": "Top",
      "controls": "slider",
      "units": ["px"],
      "min": -100,
      "max": 100,
      "step": 1,
      "default": "0px",
      "responsive": true,
      "group": "Position",
      "hidden": true
    },
    "bottom": {
      "type": "string",
      "title": "Bottom",
      "controls": "slider",
      "units": ["px"],
      "min": -100,
      "max": 100,
      "step": 1,
      "default": "0px",
      "responsive": true,
      "group": "Position",
      "hidden": true
    },
    "left": {
      "type": "string",
      "title": "Left",
      "controls": "slider",
      "units": ["px"],
      "min": -100,
      "max": 100,
      "step": 1,
      "default": "0px",
      "responsive": true,
      "group": "Position",
      "hidden": true
    },
    "right": {
      "type": "string",
      "title": "Right",
      "controls": "slider",
      "units": ["px"],
      "min": -100,
      "max": 100,
      "step": 1,
      "default": "0px",
      "responsive": true,
      "group": "Position",
      "hidden": true
    }
  },
  "text_block": {
    "font-family": {
      "type": "string",
      "format": "font",
      "title": "Font Family",
      "hidden": true,
      "group": "Formatting"
    },
    "align": {
      "type": "string",
      "title": "Align",
      "enum": ["left", "center", "right"],
      "responsive": true,
      "group": "Formatting"
    },
    "color": {
      "type": "string",
      "format": "color",
      "title": "Color",
      "group": "Formatting"
    },
    "line-height": {
      "type": "string",
      "title": "Line Height",
      "controls": "slider",
      "units": [],
      "min": 1,
      "max": 3,
      "step": 0.1,
      "default": "1",
      "hidden": true,
      "group": "Formatting"
    }
  },
  "hero_block": {
    "height": {
      "type": "string",
      "title": "Height",
      "units": ["px", "%"],
      "responsive": true,
      "controls": "slider",
      "min": 20,
      "max": 1000,
      "step": 10,
      "default": "200px",
      "group": "Display"
    },
    "border-radius": {
      "type": "string",
      "controls": "quad",
      "title": "Corner Radius",
      "units": ["px"],
      "group": "Styles",
      "icons": [
        "corner-top-left",
        "corner-top-right",
        "corner-bottom-right",
        "corner-bottom-left"
      ],
      "responsive": true,
      "hidden": true
    }
  },
  "button_block": {
    "display": {
      "type": "string",
      "title": "Display",
      "enum": ["block", "inline"],
      "default": "block",
      "group": "Styles",
      "responsive": true
    },
    "align": {
      "type": "string",
      "title": "Align",
      "enum": ["left", "center", "right"],
      "default": "left",
      "group": "Styles",
      "responsive": true,
      "hidden": true
    },
    "border-radius": {
      "type": "string",
      "controls": "quad",
      "title": "Corner Radius",
      "units": ["px"],
      "group": "Styles",
      "icons": [
        "corner-top-left",
        "corner-top-right",
        "corner-bottom-right",
        "corner-bottom-left"
      ],
      "default": "12px",
      "responsive": true,
      "hidden": true
    }
  },
  "composed_block": {
    "border-radius": {
      "type": "string",
      "controls": "quad",
      "title": "Corner Radius",
      "units": ["px"],
      "group": "Styles",
      "icons": [
        "corner-top-left",
        "corner-top-right",
        "corner-bottom-right",
        "corner-bottom-left"
      ],
      "responsive": true,
      "hidden": true
    }
  }
}
